<div [hidden]="isSessionActive && embed">
  <div class="d-flex mb-4 flex-column align-items-start flex-lg-row align-items-lg-end mt-2">
    <h4 class="me-2 mb-0">{{ 'orderProcess.payment.contactForm.title' | translate }}</h4>
    <div class="text-primary cursor-pointer font-md d-none d-sm-block"
         [translate]="'orderProcess.payment.whyDoAskInfo.question'"
         ngbTooltip="{{'orderProcess.payment.whyDoAskInfo.answer' | translate}}">
    </div>
  </div>

  <payment-contact-info
    [userInfo]="info"
    [countryCode]="countryCode"
    [personType]="personType"
    [askForReferenceField]="personType === PAYMENT_PERSON_TYPES.COMPANY"
    [bakeryId]="bakeryId"
    [useCompanySearcher]="useCompanySearcher"
    (onInfoUpdated)="infoUpdated($event)"
    (onValidUpdated)="isValid = $event"
    (onCompanySelected)="onCompanySelected.emit($event)"
  ></payment-contact-info>

  <div class="mt-4 mb-4">
    <ui-newsletter-signup
      class="d-block mb-3"
      *ngIf="!alreadySubscriber"
      [isSubscribe]="info?.subscribedOnNews"
      (onChange)="newsletterUpdate($event)"
    ></ui-newsletter-signup>
  </div>

  <div>
    <button class="btn btn-pink btn-xl mb-4"
            [disabled]="!isValid"
            (click)="confirm($event)">
      {{ 'orderProcess.payment.bambora.confirm' | translate }}
    </button>

    <terms-and-conditions (onTermsClick)="onTermsClick.emit()">
    </terms-and-conditions>

    <ng-content></ng-content>
  </div>
</div>

<div class="position-relative" [hidden]="!isSessionActive || !embed">
  <ui-back-button
    class="d-block mb-4"
    [showTextOnlyOnDesktop]="false"
    [translateKey]="'orderProcess.payment.bambora.backToContactDetails'"
    (onClick)="cancelSession()"
  ></ui-back-button>

  <div class="embed-container" #embedContainer></div>
</div>
